module.exports = __webpack_public_path__ + "static/media/broccoli-emoji.e88ae38d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/broccoli-emoji.png
// module id = 34
// module chunks = 0